export const StorageInformation = {
    user: 'User',
    bucketProfile: 'users',
    bucketCustomer: 'customers',
    lastPage: 'lastPage',
    dashboardCounter: 'dashboardCounter',
    dashboardDates: 'dashboardDates',
    dashboardIsCalendar: 'dashboardIsCalendar',
    dashboardIsTotal: 'dashboardIsTotal',
    dashboardKpiComplaintType: 'dashboardKpiComplaintType',
    dashboardKpiReclassificationType: 'dashboardKpiReclassificationType',
    dashboardKpiFlow: 'dashboardKpiFlow',
    dashboardKpiRange: 'dashboardKpiRange',
    dashboardKpiTimeRange: 'dashboardKpiTimeRange',
    dashboardSubsidiary: 'dashboardSubsidiary',
}
